import React, { Component } from 'react';
import { Modal, ModalFooter, ModalTitle, ModalBody, ModalHeader } from '@common/components/modal';
import { I18n } from 'react-redux-i18n';
import isEqual from 'lodash/isEqual';
import PropTypes from 'prop-types';
import { Button } from '@common/components/Button';
import { FormControl } from '@common/components/form-control';
import MainOptions, { OPTIONS } from '../../Licensing/components/MainOptions';
import { ACTION_TYPES } from '@common/constants';

import '../styles/ClassManagement.scss';

const DEFAULT_LICENSING_OPTIONS = OPTIONS.reduce((acc, item) => {
    acc[item.id] = true;

    return acc;
}, {});

export default class ClassManagement extends Component {
    static propTypes = {
        create: PropTypes.func.isRequired,
        edit: PropTypes.func.isRequired,
        showError: PropTypes.func.isRequired,
        item: PropTypes.object,
    };

    static defaultProps = {
        item: {}
    };

    constructor(props) {
        super(props);

        const { item } = props;
        const name = item.name || '';
        const licensing = item.licensing || DEFAULT_LICENSING_OPTIONS;

        this.state = {
            name,
            licensing,
        };
    }

    get config() {
        const { edit, create } = this.props;

        return {
            [ACTION_TYPES.edit]: {
                submitButton: 'OK',
                title: 'Edit User Class',
                warningTitle: 'Edit Class',
                onSubmit: edit,
            },
            [ACTION_TYPES.create]: {
                submitButton: 'Add',
                title: 'New User Class',
                warningTitle: 'Add Class',
                onSubmit: create,
            },
        };
    }

    onOptionsChange = (options) => {
        this.setState((state) => ({
            ...state,
            licensing: options,
        }));
    }

    onNameChange = (e) => {
        e.persist();

        this.setState((state) => ({
            ...state,
            name: e.target.value,
        }));
    }

    onNameBlur = (e) => {
        e.persist();

        this.setState((state) => ({
            ...state,
            name: e.target.value.trim(),
        }));
    }

    onSubmit = async () => {
        const { licensing, name } = this.state;
        const { showError } = this.props;

        if ((name.trim()).length === 0) {
            const { actionType } = this.props;
            
            return showError({
                title: I18n.t(this.config[actionType].warningTitle), 
                description: I18n.t('classNameEmptyError')
            });
        }

        const { actionType, close, item } = this.props;
        const data = { licensing, name, id: item.id };

        if (actionType === ACTION_TYPES.edit && isEqual(item, data)) {
            return close();
        }

        try {
            await this.config[actionType].onSubmit(data);

            close();
        } catch (err) {
            console.error(err);
            showError({
                title: I18n.t('Operation Cancelled'), 
                description: err?.entity || I18n.t('An error occurred while saving data')
            });
        }
    }

    render() {
        const { actionType, close, item } = this.props;
        const { name } = this.state;
        const config = this.config[actionType];

        return (
            <Modal 
                show
                backdrop="static"
                bsClass="bootstrap modal"
                className="ClassManagement"
                dialogClassName="ClassManagement__dialog"
                animation={false}
                onEscapeKeyDown={close}
                onHide={close}
            >
                <ModalHeader closeButton onHide={close} className="ClassManagement__dialog__header">
                    <ModalTitle id="cls-management-header">{config.title}</ModalTitle>
                </ModalHeader>
                <ModalBody>
                    <div className="ClassManagement__dialog__controls">
                        <span id="lbl-cm-class-name" className="ClassManagement__dialog__controls__name-label">{I18n.t('Class Name:')}</span>
                        <FormControl id="tx-cm-class-name" type="text" value={name} onChange={this.onNameChange} onBlur={this.onNameBlur} />
                        <div className="ClassManagement__dialog__controls__buttons">
                            <Button id="btn-cm-submit" onClick={this.onSubmit}>{config.submitButton}</Button>
                            <Button id="btn-cm-cancel" onClick={close}>{I18n.t('Cancel')}</Button>
                        </div>
                    </div>
                    <MainOptions
                        className="ClassManagement__dialog__options"
                        options={item.licensing || DEFAULT_LICENSING_OPTIONS} 
                        onChange={this.onOptionsChange}
                    />
                </ModalBody>
            </Modal>
        );
    }
}